// Personalized AM/PM routines for every skin and hair type, per spec.

export const SKIN_ROUTINES = {
  "Dry": {
    AM: [
      "Gentle cream cleanser",
      "Hydrating toner with hyaluronic acid",
      "Vitamin C serum",
      "Rich moisturizer",
      "SPF 50 sunscreen",
    ],
    PM: [
      "Oil-based cleanser",
      "Gentle foam cleanser",
      "Hydrating essence",
      "Retinol serum (2-3x per week)",
      "Heavy night cream",
    ],
  },
  "Oily": {
    AM: [
      "Foaming gel cleanser",
      "Alcohol-free toner",
      "Niacinamide serum",
      "Oil-free moisturizer",
      "Matte SPF 50",
    ],
    PM: [
      "Micellar water",
      "Salicylic acid cleanser",
      "BHA exfoliant (3x per week)",
      "Lightweight gel moisturizer",
      "Spot treatment",
    ],
  },
  "Combination": {
    AM: [
      "Balancing gel cleanser",
      "Hydrating toner",
      "Niacinamide + hyaluronic serum",
      "Lightweight moisturizer",
      "SPF 50",
    ],
    PM: [
      "Double cleanse",
      "Gentle toner",
      "Retinol on dry areas",
      "Gel on T-zone, cream on cheeks",
    ],
  },
  "Sensitive": {
    AM: [
      "Fragrance-free micellar water",
      "Calming toner",
      "Centella asiatica serum",
      "Barrier-repair moisturizer",
      "Mineral SPF 50",
    ],
    PM: [
      "Gentle milk cleanser",
      "Soothing essence",
      "Ceramide serum",
      "Rich barrier cream",
    ],
  },
  "Normal": {
    AM: [
      "Gentle cleanser",
      "Antioxidant toner",
      "Vitamin C serum",
      "Balanced moisturizer",
      "SPF 50",
    ],
    PM: [
      "Double cleanse",
      "Exfoliant (2x per week)",
      "Retinol or peptide serum",
      "Nourishing night cream",
    ],
  },
  "Acne-prone": {
    AM: [
      "Salicylic acid cleanser",
      "BHA toner",
      "Niacinamide serum",
      "Oil-free non-comedogenic moisturizer",
      "Non-comedogenic SPF 50",
    ],
    PM: [
      "Micellar water",
      "Salicylic acid cleanser",
      "Benzoyl peroxide spot treatment",
      "Lightweight gel moisturizer",
    ],
  },
  "Not sure": {
    AM: [
      "Gentle gel cleanser",
      "Hydrating toner",
      "Hyaluronic acid serum",
      "Lightweight moisturizer",
      "SPF 50",
    ],
    PM: [
      "Micellar water",
      "Gentle cleanser",
      "Soothing serum",
      "Moisturizer suited to how skin feels tonight",
    ],
  },
};

export const HAIR_ROUTINES = {
  "Straight 1A-1C": {
    AM: [
      "Lightweight leave-in conditioner",
      "Smoothing serum mid-lengths to ends",
      "Blow-dry with round brush",
    ],
    PM: [
      "Scalp massage with light oil",
      "Silk pillowcase or loose braid",
    ],
  },
  "Wavy 2A-2C": {
    AM: [
      "Refresh with water + leave-in spray",
      "Scrunch curl cream",
      "Diffuse or air dry",
    ],
    PM: ["Pineapple updo", "Satin bonnet or silk pillowcase"],
  },
  "Curly 3A-3C": {
    AM: [
      "Dampen hair",
      "Apply curl cream section by section",
      "Rake with wide-tooth comb",
      "Scrunch with gel",
      "Diffuse or air dry",
    ],
    PM: [
      "Pineapple hair up high",
      "Satin bonnet",
      "Refresh ends with water + leave-in",
    ],
  },
  "Coily 4A-4B": {
    AM: [
      "LOC method — liquid, oil, cream",
      "Seal ends with shea butter",
      "Style or protect",
    ],
    PM: [
      "Moisturize and seal",
      "Loose twists or protective style",
      "Satin bonnet",
    ],
  },
  "Kinky 4C": {
    AM: [
      "Spritz with water and leave-in",
      "Finger detangle gently section by section",
      "LOC method",
      "Seal with heavy butter",
      "Protective style to retain length",
    ],
    PM: [
      "Moisturize every night — 4C hair loses moisture fastest",
      "Loose twists or bantu knots",
      "Satin bonnet or satin-lined cap — non-negotiable",
    ],
  },
  "Locs": {
    AM: [
      "Spritz with rosewater or aloe vera",
      "Light loc oil to scalp and locs",
      "Re-tie loose ends",
    ],
    PM: ["Satin bonnet or scarf", "Scalp oil massage 2-3x per week"],
  },
  "Protective styles": {
    AM: [
      "Scalp spray with tea tree and peppermint",
      "Edge control if needed",
      "Light oil on exposed hair",
    ],
    PM: [
      "Moisturize scalp through braids or parts",
      "Satin scarf",
      "No tight pulling overnight",
    ],
  },
  "Chemically treated": {
    AM: [
      "Sulfate-free shampoo on wash days",
      "Bond-repair treatment",
      "Rich leave-in",
      "UV protectant spray",
    ],
    PM: [
      "No-heat styles only",
      "Protein mask weekly",
      "Satin bonnet every night",
    ],
  },
};

// Fallback if no profile selected yet
export const DEFAULT_SKIN = "Not sure";
export const DEFAULT_HAIR = "Curly 3A-3C";
